import { registerRoutingKey } from "Common/routingUtils";
import locale from "./routesMap.locale";
export default {
    WELCOME: registerRoutingKey("WELCOME"),
    WORK_SPACE: registerRoutingKey("WORK_SPACE")
};
const AREA_TITLE = locale.WELCOME;
export { AREA_TITLE };
